<script setup>
defineProps({
  color: {
    type: String,
    default: "#292929",
  },
});
</script>

<template>
  <svg
    preserveAspectRatio="xMidYMid meet"
    width="62"
    height="14"
    overflow="visible"
    viewBox="0 0 62.0008 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g>
      <path
        d="M0 14V10.8018H4.46958C4.60385 10.8018 4.71343 10.6989 4.71343 10.5713V0.419381H8.59654V10.8871C8.59654 12.6062 7.12185 14 5.303 14H0Z"
        :fill="color"
      />
      <g transform="translate(10.25, 0)">
        <path
          d="M7.40583 0C3.31592 0 0 3.13405 0 6.99963C0 10.8652 3.31592 13.9993 7.40583 13.9993H14.8117V6.99963C14.8117 3.13405 11.4957 0 7.40583 0ZM7.39271 10.9411C5.14557 10.9411 3.50961 9.28909 3.50961 6.92962C3.50961 4.57015 5.14635 2.97067 7.39271 2.97067C9.63908 2.97067 11.3036 4.59641 11.3036 6.92962C11.3036 9.26283 9.66686 10.9411 7.39271 10.9411Z"
          :fill="color"
        />
      </g>
      <g transform="translate(16.17, 5.43)">
        <path
          d="M0 1.50862C0 0.662068 0.694161 0 1.58175 0C2.46933 0 3.18275 0.662068 3.18275 1.50862C3.18275 2.35517 2.46933 3.01724 1.58175 3.01724C0.694161 3.01724 0 2.35517 0 1.50862Z"
          :fill="color"
        />
      </g>
      <path
        d="M46.9939 14H43.1108V5.19083C43.1108 4.03699 42.2233 3.19823 41.0303 3.19823C39.8373 3.19823 38.9777 4.03699 38.9777 5.19083V14H35.0946V5.19083C35.0946 4.03699 34.2071 3.19823 33.0141 3.19823C31.8211 3.19823 30.9614 4.03699 30.9614 5.19083V14H27.0783V5.24334C27.0775 2.15014 29.6851 0 32.9855 0C34.7604 0 36.1757 0.629435 37.0909 1.73003C38.0617 0.628705 39.5039 0 41.2518 0C44.5801 0 46.9939 2.15014 46.9939 5.24334V14Z"
        :fill="color"
      />
      <path
        d="M47.8813 0.419381H52.2081L54.9268 4.69268H55.0379L57.701 0.419381H61.973L57.285 7.15718L62.0008 14H57.7017L54.9283 9.64793H54.8172L52.1819 14H47.8829L52.5986 7.15718L47.8829 0.419381H47.8813Z"
        :fill="color"
      />
    </g>
  </svg>
</template>
